export type SpeechToTextProviderName = 'aws-transcribe' | 'elevenlabs';

export interface AwsTranscribeCredentials {
  provider: 'aws-transcribe';
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  region: string;
  expiresAt: string;
}

export interface ElevenLabsCredentials {
  provider: 'elevenlabs';
  wsUrl: string;
  signedToken: string;
  expiresAt: string;
}

export type SpeechToTextCredentials = AwsTranscribeCredentials | ElevenLabsCredentials;

export interface TranscribeSegment {
  text: string;
  isPartial: boolean;
}

export interface TranscribeParams {
  frames: AsyncIterable<Int16Array>;
  credentials: SpeechToTextCredentials;
  preferredLanguage?: 'fr-FR' | 'en-US';
}

interface SpeechToTextClient {
  transcribe(params: TranscribeParams): AsyncIterable<TranscribeSegment>;
}

export async function loadSpeechToTextProvider(
  name: SpeechToTextProviderName,
): Promise<SpeechToTextClient> {
  switch (name) {
    case 'aws-transcribe': {
      const mod = await import('./awsTranscribe');
      return { transcribe: mod.transcribe };
    }
    case 'elevenlabs': {
      const mod = await import('./elevenLabs');
      return { transcribe: mod.transcribe };
    }
    default: {
      const exhaustive: never = name;
      throw new Error(`Unknown SPEECH_TO_TEXT provider: ${exhaustive}`);
    }
  }
}
